<p-accordion *ngFor="let dataSource of dataSources; trackBy: trackByDataSourceId">
  <p-accordionTab
    *ngIf="dataSource && dataSource.type === 'url'"
    [iconPos]="'end'"
    expandIcon="pi pi-plus"
    collapseIcon="pi pi-minus"
  >
    <ng-template pTemplate="header">
      <div class="card-url">
        <div class="header-content">
          <div class="data-url">
            <div class="icon-container">
              <span [style.backgroundColor]="'#3E66FB'" class="circle">
                <i [ngClass]="getIcon(dataSource.type)" class="icon"></i>
              </span>
            </div>
            <span>
              <p style="margin: 0">
                <b>{{ getType(dataSource.type) + ' (' + dataSource.children.length + ')' }}:</b>
              </p></span
            >
          </div>
          <div>
            <p style="margin: 0">{{ dataSource.path }}</p>
          </div>
        </div>

        <div class="card-footer" style="margin-right: 15px">
          <div
            [ngClass]="getStatus(dataSource.status, true).chipClass"
            [pTooltip]="dataSource.error_detail || ''"
            tooltipPosition="top"
          >
            {{ getStatus(dataSource.status, true).statusText }}
            <i
              *ngIf="dataSource.error_detail"
              class="pi pi-info-circle"
              style="margin-left: 4px"
            ></i>
          </div>
          <i
            *ngIf="canDelete"
            class="pi pi-trash pointer"
            style="color: var(--color-error)"
            (click)="deleteDataSource(dataSource.id)"
          ></i>
        </div>
      </div>
    </ng-template>

    <ng-template pTemplate="content">
      <div
        *ngFor="let childSource of dataSource.children; trackBy: trackByChildId"
        class="child-datasource"
      >
        <span class="content-child">
          <input
            pInputText
            readonly
            [(ngModel)]="childSource.path"
            style="margin: 0; width: 100%"
          />
          <div class="card-footer" style="margin-left: auto; margin-right: 20px; margin-top: 0">
            <div
              [ngClass]="getStatus(childSource.status).chipClass"
              style="font-weight: 700"
              [pTooltip]="childSource.error_detail || ''"
              tooltipPosition="top"
            >
              {{ getStatus(childSource.status).statusText }}
              <i
                *ngIf="childSource.error_detail"
                class="pi pi-info-circle"
                style="margin-left: 4px"
              ></i>
            </div>
            <i
              *ngIf="canDelete"
              class="pi pi-trash pointer"
              style="color: var(--color-error)"
              (click)="deleteDataSource(childSource.id)"
            ></i>
          </div>
        </span>
      </div>
    </ng-template>
  </p-accordionTab>

  <div *ngIf="dataSource && dataSource.type !== 'url'" class="card">
    <div class="header-content">
      <div class="data-url">
        <div class="icon-container">
          <span [style.backgroundColor]="'#3E66FB'" class="circle">
            <i [ngClass]="getIcon(dataSource.type)" class="icon"></i>
          </span>
        </div>
        <span
          ><p style="margin: 0">
            <b>{{ getType(dataSource.type) }}:</b>
          </p></span
        >
      </div>

      <div>
        <p class="name-data" style="margin: 0">{{ dataSource.path }}</p>
      </div>
    </div>
    <div class="card-footer footer-file">
      <div [ngClass]="getStatus(dataSource.status).chipClass" style="font-weight: 700">
        {{ getStatus(dataSource.status).statusText }}
      </div>
      <i
        *ngIf="canDelete"
        class="pi pi-trash pointer"
        style="color: var(--color-error)"
        (click)="deleteDataSource(dataSource.id)"
      ></i>
    </div>
  </div>
</p-accordion>

<!-- <div class="card" *ngFor="let dataSource of dataSources">
    <div class="card-header">
        <div class="icon-container">
  <span [style.backgroundColor]="'#3E66FB'" class="circle">
    <i [ngClass]="getIcon(dataSource.type)" class="icon"></i>
  </span>
        </div>
        <div class="data-container">
            <p><b>{{ getType(dataSource.type) }}:</b></p>
            <p>{{ dataSource.path }}</p>
        </div>
    </div>
    <div class="card-footer">
        <div [ngClass]="getStatus(dataSource.status).chipClass">
            {{ getStatus(dataSource.status).statusText }}
        </div>
        <i class="pi pi-trash pointer" style="color: var(--color-error)"(click)="deleteDataSource(dataSource.id)"></i>
    </div>
</div> -->

<p-confirmDialog #dataSourceDelete>
  <ng-template pTemplate="header">
    <h3>Eliminar Fuente de datos</h3>
  </ng-template>
  <ng-template pTemplate="footer">
    <button
      pButton
      pRipple
      type="button"
      label="Cancelar"
      class="p-button-text"
      (click)="dataSourceDelete.reject()"
    ></button>
    <button
      type="button"
      pButton
      label="Eliminar"
      class="p-button-danger"
      (click)="dataSourceDelete.accept()"
    ></button>
  </ng-template>
</p-confirmDialog>
